import { render } from "./adminone.vue?vue&type=template&id=33863dda&scoped=true"
import script from "./adminone.vue?vue&type=script&lang=js"
export * from "./adminone.vue?vue&type=script&lang=js"

import "./adminone.vue?vue&type=style&index=0&id=33863dda&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33863dda"]])

export default __exports__